/**
 * Ajustes visuais locais da tela de Correção de Balanços.
 *
 * O variant "ghost" do Button compartilhado (src/components/ui/button.tsx) está
 * fixado em `text-white` + `hover:bg-gray-800`, herança de uma paleta escura.
 * Dentro dos cards desta tela — que usam `bg-card` e seguem o tema — isso deixa
 * o texto branco sobre fundo branco no Light Mode, praticamente ilegível.
 *
 * Aqui o botão volta a usar os tokens de tema do projeto, exatamente como o
 * ghost canônico do shadcn/ui. Como `cn()` usa tailwind-merge, estas classes
 * substituem as do variant em vez de apenas concorrer com elas.
 *
 * A correção é local de propósito: o variant compartilhado é usado em mais de
 * 160 pontos do sistema e alterá-lo agora mudaria a aparência de telas fora
 * deste escopo.
 */
export const GHOST_BUTTON_CLASS =
  "text-foreground hover:bg-accent hover:text-accent-foreground";
